export default __webpack_public_path__ + "static/media/notifications.6ff64301.svg";